import { SuggestionItemV2 } from "../analysis/chat/EmptyChatStateV2";
import {
  BarChart3,
  Sparkles,
  Quote,
  Film,
  Lightbulb,
  Compass,
  Scale,
  Presentation,
  NotebookPen,
} from "lucide-react";

export const MISSION_CONTROL_CHAT_TITLE = "Welcome to your Research Library";

const FEATURE_CLASSNAME = "w-12 h-12";
const FEATURE_PROPS = { strokeWidth: 1.5, absoluteStrokeWidth: true };

export const MISSION_CONTROL_CHAT_FEATURES = [
  {
    icon: <Sparkles className={FEATURE_CLASSNAME} {...FEATURE_PROPS} />,
    text: "What can I help you discover?",
  },
  {
    icon: <Compass className={FEATURE_CLASSNAME} {...FEATURE_PROPS} />,
    text: "Explore the research in your workspace",
  },
  {
    icon: <NotebookPen className={FEATURE_CLASSNAME} {...FEATURE_PROPS} />,
    text: "Write cross-study memos",
  },
  {
    icon: <Scale className={FEATURE_CLASSNAME} {...FEATURE_PROPS} />,
    text: "Compare insights between studies",
  },
  {
    icon: <Quote className={FEATURE_CLASSNAME} {...FEATURE_PROPS} />,
    text: "Discover quotes across all studies",
  },
  {
    icon: <BarChart3 className={FEATURE_CLASSNAME} {...FEATURE_PROPS} />,
    text: "Generate charts across studies",
  },
  {
    icon: <Presentation className={FEATURE_CLASSNAME} {...FEATURE_PROPS} />,
    text: "Build presentations",
  },
];

const SUGGESTION_CLASSNAME = "w-4 h-4 stroke-1";

// Phrased like the study agent's asks, about the research rather than "our
// product". Six, because that is what the grid shows, and every one of them
// reads across studies: the reel is the library's own, not a study's.
export const MISSION_CONTROL_CHAT_SUGGESTIONS: SuggestionItemV2[] = [
  {
    suggestion: "What are the key takeaways across our recent studies?",
    icon: <Sparkles className={SUGGESTION_CLASSNAME} />,
  },
  {
    suggestion: "Write a memo comparing the last three studies",
    icon: <NotebookPen className={SUGGESTION_CLASSNAME} />,
  },
  {
    suggestion: "Build a presentation from our recent research",
    icon: <Presentation className={SUGGESTION_CLASSNAME} />,
  },
  {
    suggestion: "Cut a highlight reel from clips across our studies",
    icon: <Film className={SUGGESTION_CLASSNAME} />,
  },
  {
    suggestion: "Which themes keep coming up across studies?",
    icon: <Lightbulb className={SUGGESTION_CLASSNAME} />,
  },
  {
    suggestion: "Find compelling quotes across all our interviews",
    icon: <Quote className={SUGGESTION_CLASSNAME} />,
  },
];

// The AgentExecutor chat has no memo or presentation tools yet, so it does not suggest them.
export const AGENT_EXECUTOR_CHAT_SUGGESTIONS: SuggestionItemV2[] = [
  {
    suggestion: "What are the key takeaways across our recent studies?",
    icon: <Sparkles className={SUGGESTION_CLASSNAME} />,
  },
  {
    suggestion: "Compare what participants said about pricing across studies",
    icon: <Scale className={SUGGESTION_CLASSNAME} />,
  },
  {
    suggestion: "Chart how sentiment differs between our recent studies",
    icon: <BarChart3 className={SUGGESTION_CLASSNAME} />,
  },
  {
    suggestion: "Cut a highlight reel from clips across our studies",
    icon: <Film className={SUGGESTION_CLASSNAME} />,
  },
  {
    suggestion: "Which themes keep coming up across studies?",
    icon: <Lightbulb className={SUGGESTION_CLASSNAME} />,
  },
  {
    suggestion: "Find compelling quotes across all our interviews",
    icon: <Quote className={SUGGESTION_CLASSNAME} />,
  },
];
